"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Play } from "lucide-react";
import { useState } from "react";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "@/components/ui/sheet";
export default function DemoVideos() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const [selectedVideo, setSelectedVideo] = useState<number | null>(null);
  const videos = [{
    id: 1,
    title: "KI-Anrufannahme Demo",
    embedUrl: "https://www.youtube.com/embed/dQw4w9WgXcQ",
    thumbnail: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1515015/img/ai_call_reception_thumbnail.png"
  }, {
    id: 2,
    title: "Intelligente Fragebeantwortung",
    embedUrl: "https://www.youtube.com/embed/dQw4w9WgXcQ",
    thumbnail: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1515015/img/ai_appointment_booking_thumbnail.png"
  }, {
    id: 3,
    title: "Automatische Terminbuchung",
    embedUrl: "https://www.youtube.com/embed/dQw4w9WgXcQ",
    thumbnail: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1515015/img/customer_support_247_thumbnail.png"
  }, {
    id: 4,
    title: "Komplette KI-Assistent Demonstration",
    embedUrl: "https://www.youtube.com/embed/dQw4w9WgXcQ",
    thumbnail: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1515015/img/complete_ai_assistant_demo_thumbnail.png"
  }];
  const selectedVideoData = videos.find(v => v.id === selectedVideo);
  return <section ref={sectionRef} className="bg-dark-background py-16 px-4 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-7xl">
        <div className="mb-12 text-center">
          
          <p className={`text-foreground-muted-dark mx-auto mt-4 max-w-2xl text-xl transition-all duration-[var(--duration-medium)] delay-100 ${isVisible ? "translate-y-0 opacity-100" : "translate-y-[0.625rem] opacity-0"}`}>Der letzte schritt um ihren eigenen Virtuellen Asisstenten JETZT&nbsp; in Aktion zu sehen</p>
        </div>

        
      </div>

      <Sheet open={selectedVideo !== null} onOpenChange={open => !open && setSelectedVideo(null)}>
        <SheetContent side="bottom" className="h-[90vh] w-full rounded-t-lg bg-background p-0">
          <SheetHeader className="border-b border-border p-6">
            <SheetTitle className="text-foreground font-display text-xl">
              {selectedVideoData?.title}
            </SheetTitle>
          </SheetHeader>
          <div className="flex h-[calc(100%-5rem)] w-full items-center justify-center p-6">
            {selectedVideoData && <div className="relative w-full max-w-5xl">
                <div className="relative w-full pt-[56.25%]">
                  <iframe src={selectedVideoData.embedUrl} title={selectedVideoData.title} className="absolute top-0 left-0 h-full w-full rounded-lg shadow-medium" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen />
                </div>
              </div>}
          </div>
        </SheetContent>
      </Sheet>
    </section>;
}